export default {
  label: "Projects",
  deleteProject: "Delete Project",
  deleteProjectErrorMessage:
    "This project cannot be deleted as one or more assets exist for the project. Please assign them to another project first.",
  deleteProjectMessage: "Do you really want to delete the project?",
};
